// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".searchPage-root-MfJ {\n}\n\n.searchPage-noResult-LaX {\n}\n.searchPage-breadcrumbs-GCL {\n}\n\n.searchPage-headerButtons-vK9 {\n    flex-basis: 100%;\n}\n\n.searchPage-heading-MLF {\n}\n\n.searchPage-searchContent-Ui4 {\n}\n\n.searchPage-searchInfo-vt5 {\n}\n\n@media (min-width: 960px) {\n    .searchPage-searchInfo-vt5 {\n        flex-basis: 100%;\n    }\n}\n\n.searchPage-totalPages-4kY {\n}\n\n.searchPage-headingHighlight-Krp {\n}\n\n.searchPage-sidebar-5dr {\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "searchPage-root-MfJ p-xs lg_flex lg_flex-nowrap",
	"noResult": "searchPage-noResult-LaX flex",
	"breadcrumbs": "searchPage-breadcrumbs-GCL mt-9",
	"headerButtons": "searchPage-headerButtons-vK9 flex justify-center mx-0 my-xs lg_justify-end",
	"heading": "searchPage-heading-MLF flex flex-wrap justify-center lg_flex-nowrap lg_items-center lg_justify-between",
	"searchContent": "searchPage-searchContent-Ui4 lg_flex-grow",
	"searchInfo": "searchPage-searchInfo-vt5 leading-tight max-w-[75vw] mb-xs ml-0 mr-0 mt-10 lg_m-0",
	"totalPages": "searchPage-totalPages-4kY ml-2xs",
	"headingHighlight": "searchPage-headingHighlight-Krp font-bold",
	"sidebar": "searchPage-sidebar-5dr hidden lg_flex lg_self-start lg_pt-16 lg_w-filterSidebarWidth"
};
export default ___CSS_LOADER_EXPORT___;
